import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const Backdrop = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(17, 19, 20, 0.75);
`;

const Panel = styled.div`
	width: 1020px;
	padding: 20px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow: 0 6px 80px rgba(0, 0, 0, 0.5);
	border-radius: 10px;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 20px;

	${Text} {
		font-size: 18px;
		font-weight: 700;
		color: #fff;
	}
`;

const Screenshot = styled.img`
	display: block;
	width: 100%;
	height: 540px;
	object-fit: contain;
	background: #090a0a;
	border-radius: 6px;
`;

export { Backdrop, Header, Panel, Screenshot };
